import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { GLOBAL } from './global.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { BranchFilter } from '../models/branch';

@Injectable()
export class BranchService {
   public url;
   public service: string = 'branchService';

   constructor(private _http: HttpClient) {
      this.url = GLOBAL.url;
   }

   getList(branchFilter: BranchFilter) {
      let params: HttpParams = new HttpParams();

      if (branchFilter.businessName) {
         params = params.set('businessName', branchFilter.businessName)
      }
      if (branchFilter.responsible) {
         params = params.set('responsible', branchFilter.responsible)
      }

      return this._http.get(this.url + this.service + '/listSearch/' + branchFilter.page,
        { responseType: 'text', observe: 'response', headers: new HttpHeaders(), params: params }).pipe(map(res => {            
           return res
        }));
   }

   get(id) {
      return this._http.get(this.url + this.service + '/' + id,
        { responseType: 'text', observe: 'response', headers: new HttpHeaders() }).pipe(map(res => {            
           return res
        }));
   }

   save(branch) {
      let body = JSON.stringify(branch);
      return this._http.post(this.url + this.service, body, { observe: 'response', headers: new HttpHeaders() }
      ).pipe(map(
         res => {            
            return res
         }
      ));
   }

   update(branch) {
      let body = JSON.stringify(branch);
      return this._http.put(this.url + this.service, body, { observe: 'response', headers: new HttpHeaders() }
      ).pipe(map(res => {         
         return res
      }));
   }

   delete(id) {
      return this._http.delete(this.url + this.service + '/' + id, { observe: 'response', headers: new HttpHeaders() }
      ).pipe(map(res => {         
         return res
      }));
   }

   getFilterBranchLocalStorage(): BranchFilter{
      let filter: BranchFilter = new BranchFilter();
      filter = JSON.parse(localStorage.getItem('branch-filter-list'));
      return filter;
   }

   setfilterLocalStorage(filter: BranchFilter){
      localStorage.setItem('branch-filter-list', JSON.stringify(filter));
   }
}
